import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;

@Component({
  selector: 'app-list-intervencion',
  templateUrl: './list-intervencion.component.html',
  styleUrls: [],
  providers: [GeneralService]
})
export class ListIntervencionComponent implements OnInit {
  techos: any[];
  oTechos: any[];
  baseUrl = environment.apiEndpoint;
  techoId: number;
  popupVisibleEstado: boolean = false;
  popupVisibleO: boolean = false;
  popupVisibleEstadoA: boolean = false;
  rol: number = 0;
  gestion: string ='';
  constructor(private _gs: GeneralService) {
    this.getTechoByUO();
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null)
      this.rol = u.rol;
      this.gestion = localStorage.getItem('g');      
  }

  ngOnInit() {
  }

  getTechoByUO() {
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {
      this._gs.getTechoByUO(u.unidad).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.techos = result.data;
          } else {
            this.techos = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  showModalEnviarRevision(id: number) {
    this.techoId = id;
    this.popupVisibleEstado = true;
  }

  showModalEnviarAprobacion(id: number) {
    this.techoId = id;
    this.popupVisibleEstadoA = true;
  }

  enviarRevision() {
    this._gs.updateEstadoTecho({ id: this.techoId }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTechoByUO();
          this.popupVisibleEstado = false;
          toastr.success('Operación realizada exitosamente.');          
        }
        else if (result.status == 201) {
          this.popupVisibleEstado = false;
          toastr.warning(result.data);
        }
      },
      (error) => { console.log('Error', error); });
  }


  enviarAprobacion() {
    this._gs.updateEstadoTechoJue({ id: this.techoId }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTechoByUO();
          this.popupVisibleEstadoA = false;
          toastr.success('Operación realizada exitosamente.');          
        }
        else if (result.status == 201) {
          this.popupVisibleEstadoA = false;
          toastr.warning(result.data);
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalObs(id: number) {
    this._gs.getObservacionesTecho(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.oTechos = result.data;
        } else {
          this.oTechos = [];
        }
      });
    this.popupVisibleO = true;
  }
}
